(() => {
  const hydrate = (root) => {
    root.querySelectorAll('[data-srcset]').forEach((element) => {
      element.srcset = element.dataset.srcset;
      element.removeAttribute('data-srcset');
    });

    root.querySelectorAll('img[data-src]').forEach((image) => {
      image.src = image.dataset.src;
      image.removeAttribute('data-src');
    });

    root.querySelectorAll('source[data-src]').forEach((source) => {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
    });

    root.querySelectorAll('video').forEach((video) => {
      if (!video.querySelector('source[src]')) return;

      video.load();
      if (video.dataset.deferredAutoplay === 'true') {
        video.play().catch(() => {});
      }
    });

    root.querySelectorAll('[data-bg-image-set]').forEach((element) => {
      element.style.backgroundImage = `image-set(${element.dataset.bgImageSet})`;
      element.removeAttribute('data-bg-image-set');
    });
  };

  const observe = () => {
    const roots = Array.from(document.querySelectorAll('[data-deferred-media-root]'));
    if (!roots.length) return;

    if (!('IntersectionObserver' in window)) {
      roots.forEach(hydrate);
      return;
    }

    const interactionOnlyRoots = roots.filter((root) => root.dataset.deferredMediaMode === 'interaction');
    const observableRoots = roots.filter((root) => root.dataset.deferredMediaMode !== 'interaction');

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          hydrate(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '800px 0px' }
    );

    observableRoots.forEach((root) => observer.observe(root));

    const hydrateAll = () => {
      roots.forEach((root) => {
        hydrate(root);
        if (!interactionOnlyRoots.includes(root)) {
          observer.unobserve(root);
        }
      });
    };

    ['scroll', 'wheel', 'touchstart', 'pointerdown', 'keydown'].forEach((eventName) => {
      window.addEventListener(eventName, hydrateAll, { once: true, passive: true });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe, { once: true });
  } else {
    observe();
  }
})();
